import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { ServerStateInterface } from "../../../interfaces/AdapterCdoOpc.interface";

export default function FormSelectOpcSelectServerState({
	inputValue,
	inputOnChange,
	disabledInput,
}: {
	inputValue: ServerStateInterface;
	inputOnChange: (newValue: ServerStateInterface) => void;
	disabledInput: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");
	const OPTIONS: ServerStateInterface[] = [
		"OPC_STATUS_RUNNING",
		"OPC_STATUS_FAILED",
		"OPC_STATUS_NOCONFIG",
		"OPC_STATUS_SUSPENDED",
		"OPC_STATUS_TEST",
		"OPC_STATUS_COMM_FAULT",
		"UNKNOWN",
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{t("general.contentType")}</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							inputOnChange(e);
						}}
						value={inputValue}
						disabled={disabledInput}
					>
						{OPTIONS.map((item: ServerStateInterface) => (
							<Option key={item} value={item}>
								{item}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
